import React from 'react'
import Settings from 'src/components/settings'
import PageHeader from 'src/components/shared/page-header'

const SettingsPage: React.FC = () => {

  return (
    <div className="min-h-screen w-full flex flex-col">
      <PageHeader title='App Settings' />
      <div className="flex flex-col gap-2">
         <Settings/>
      </div>
    </div>
  )
}

export default SettingsPage
